import API from 'utils/API'
import config from 'app/config'
import { v4 as uuidv4 } from 'uuid'
import Cookies from 'js-cookie'

const InitTracker = (event_name, ...additional_params) => {
  const tracker_data = JSON.parse(Cookies.get('sp'))
  const loc_data = JSON.parse(Cookies.get('loc'))
  const page_name = Cookies.get('page_name')

  const data = {
    id: uuidv4(),
    timestamp: new Date(),
    app_name: config.app_name,
    app_version: config.app_version,
    event_name: event_name,
    event_version: config.tracker_version,
    event_type: 'EVENT_TYPE_CREATED',
    event_data: [
      {
        key: 'cookie_id',
        value: tracker_data.cookie_id,
      },
      {
        key: 'ip_address',
        value: tracker_data.ip_address,
      },
      {
        key: 'device_type',
        value: tracker_data.device_type,
      },
      {
        key: 'device_brand',
        value: tracker_data.device_brand,
      },
      {
        key: 'operating_system',
        value: tracker_data.operating_system,
      },
      {
        key: 'browser_name',
        value: tracker_data.browser_name,
      },
      {
        key: 'screen_height',
        value: tracker_data.screen_height.toString(),
      },
      {
        key: 'screen_width',
        value: tracker_data.screen_width.toString(),
      },
      {
        key: 'referrer',
        value: tracker_data.referrer,
      },
      {
        key: 'lat',
        value: loc_data.lat.toString(),
      },
      {
        key: 'long',
        value: loc_data.long.toString(),
      },
      {
        key: 'page_name',
        value: page_name,
      },
      ...additional_params
    ],
  }

  return JSON.stringify(data)
}

export const ShootTracker = (event_name, ...additional_params) => {
  const payload = {
    event_name: `${config.tracker_name}_${config.tracker_version}`,
    data: InitTracker(event_name, ...additional_params),
  }

  new Promise((resolve, reject) =>
    API.post(`${config.api_url}${config.tracker_path}`, payload, {
      headers: { Authorization: `Bearer ${config.api_key}` },
    })
    .then((response) => {
      const { data, message } = response.data
      if (message === 'OK') {
        resolve(data)
      } else {
        reject(data)
      }
    })
    .catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    }),
  )
}
